import React, {useEffect, useState} from 'react';
import {Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Row, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import businessHelper from "../../helpers/BusinessHelper";
import constants from "../../shared/constants";
import {func} from "prop-types";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
let reportStrings = new LocalizedStrings(report_strings);

const reportCardStyle = {minHeight: 140}

const DayOverview = (props) => {
    const [data, setData] = useState(props.data);
    const [locales, setLocales] = useState(props.locales);

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    localize();

    function ticketsCount() {
        return data.tickets ? data.tickets.length : 0
    }

    function ticketTotal() {
        return businessHelper.currency() + (data.tickets && data.tickets.length > 0 ? (data.tickets.map(it => parseFloat(it.price || "0")) || [0]).reduce((a, b) => a + b) : 0).toFixed(2)
    }

    function classAmount() {
        return data.classes ? data.classes.length : 0
    }

    function attendance() {
        return (data.classes && data.classes.length > 0 ? data.classes.map(it => it.students).reduce((a, b) => a + b) : 0) + bookings()
    }

    function confirmedAttendance() {
        return (<span style={{fontSize: "0.8rem", color: "gray"}}>
            {" "}{(data.classes && data.classes.length > 0 ? data.classes.map(it => it.confirmed_bookings).reduce((a, b) => a + b) : 0)}{` ${resourceStrings.confirmed_booking.toLowerCase()}`}
        </span>)
    }

    function bookings() {
        return (data.classes && data.classes.length > 0 ? data.classes.map(it => it.bookings).reduce((a, b) => a + b) : 0)
    }

    function localeName(cashier) {
        if (cashier.locale_id) {
            const loc = locales.find((locale) => {
                return locale.id == cashier.locale_id
            })
            if (loc) {
                return loc.title
            }
        } else {
            return ""
        }
    }

    function cashierDayStart(cashier) {
        return `${reportStrings.start_total}: ${businessHelper.currency()}${(parseFloat(cashier.start_total) / 100).toFixed(2)}`;
    }

    function cashierDayEnd(cashier) {
        return `${reportStrings.day_total}: ${businessHelper.currency()}${(parseFloat(cashier.total) / 100).toFixed(2)}`;
    }

    function redirectToTicketReportReport() {
        if (props.redirectToReport) {
            props.redirectToReport(constants.reports.ticketReport, props.period, null)
        }
    }

    const handleChange = (e) => {
        switch (e.target.id) {
            case "input-all-locales-cb":
                props.toggleAllLocales(props.reportType, e.target.checked)
                break;
            default:
                break;
        }
    };

    function hasManyLocales() {
        return locales && locales.length > 1
    }

    return (
        <div>
            {hasManyLocales() &&
                <Row>
                    <Col className="col-sm mb-4">
                        <div className="col">
                            <FormGroup>
                                <div className="custom-control custom-checkbox"
                                     style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>
                                    <input
                                        className="custom-control-input"
                                        id="input-all-locales-cb"
                                        type="checkbox"
                                        onChange={handleChange}
                                        checked={props.allLocales}
                                    />
                                    <label className="custom-control-label text-white" htmlFor="input-all-locales-cb">
                                        {commonStrings.business.all_locales}
                                    </label>
                                </div>
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            }

            <Row style={{padding: "1rem"}}>
                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.tickets_sold}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {ticketsCount()}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-success text-white rounded-circle shadow">
                                        <i className="fas fa-ticket-alt"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                                <small className="text-gray mr-2 text-underline" style={{cursor: "pointer"}}
                                       onClick={redirectToTicketReportReport}>{reportStrings.go_to_ticket_report}</small>
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.ticket_sales}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {ticketTotal()}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-success text-white rounded-circle shadow">
                                        {businessHelper.currency()}
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                                <small className="text-gray mr-2 text-underline" style={{cursor: "pointer"}}
                                       onClick={redirectToTicketReportReport}>{reportStrings.go_to_ticket_report}</small>
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.expenses}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {businessHelper.currency() + (data.expenses && data.expenses.length > 0 ? (data.expenses.map(it => it.price * it.qty) || [0]).reduce((a, b) => a + b) : 0).toFixed(2)}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-danger text-white rounded-circle shadow">
                                        <i className="fas fa-money-check-alt"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                                {/*<span className="text-gray mr-2 text-underline" style={{cursor: "pointer"}}>*/}
                                {/*    <small>{reportStrings.go_to_expenses}</small>*/}
                                {/*</span>*/}
                            </p>
                        </CardBody>
                    </Card>
                </Col>
                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.incomes}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {businessHelper.currency() + (data.incomes && data.incomes.length > 0 ? (data.incomes.map(it => it.price * it.qty) || [0]).reduce((a, b) => a + b) : 0).toFixed(2)}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                        <i className="fas fa-money-check-alt"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                                {/*<span className="text-gray mr-2 text-underline" style={{cursor: "pointer"}}>*/}
                                {/*    <small>{reportStrings.go_to_incomes}</small>*/}
                                {/*</span>*/}
                            </p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row style={{padding: "1rem"}}>
                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.new_clients}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {data.new_students || 0}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-danger text-white rounded-circle shadow">
                                        <i className="fas fa-user"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-success mr-2">
                            </span>
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {resourceStrings.classes}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {classAmount()}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-warning text-white rounded-circle shadow">
                                        <i className="fas fa-calendar-week"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-success mr-2">
                            </span>
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.attendance}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {attendance()}
                                        {confirmedAttendance()}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-success text-white rounded-circle shadow">
                                        <i className="fas fa-users"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-gray mr-2">
                                <small>{reportStrings.attendance_expl}</small>
                            </span>
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col className="col-sm">
                    <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                        <CardBody>
                            <Row>
                                <div className="col">
                                    <CardTitle
                                        tag="h5"
                                        className="text-uppercase text-muted mb-0"
                                    >
                                        {reportStrings.bookings}
                                    </CardTitle>
                                    <span className="h2 font-weight-bold mb-0">
                                    {bookings()}
                          </span>
                                </div>
                                <Col className="col-auto">
                                    <div
                                        className="icon icon-shape bg-primary text-white rounded-circle shadow">
                                        <i className="fas fa-mobile-alt"/>
                                    </div>
                                </Col>
                            </Row>
                            <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-gray mr-2">
                                <small>{reportStrings.bookings_expl}</small>
                            </span>
                            </p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {locales && data.cashiers && data.cashiers.length > 0 &&
                <Row style={{padding: "1rem"}}>
                    {data.cashiers.map((cashier, index) => {
                        return (
                            <Col className="col-sm">
                                <Card className="card-stats mb-4 mb-xl-0" style={reportCardStyle}>
                                    <CardBody>
                                        <Row>
                                            <div className="col">
                                                <CardTitle
                                                    tag="h5"
                                                    className="text-uppercase text-muted mb-0"
                                                >
                                                    {resourceStrings.cabinet.cashier}
                                                </CardTitle>
                                                <span className="h2 font-weight-bold mb-0"
                                                      style={{display: "flex", flexFlow: "column"}}>
                                                    <small className="text-capitalize">
                                                        {localeName(cashier)}
                                                    </small>

                                                    <div className="text-sm text-gray-dark mt-2 text_caps-small">
                                                    {cashierDayStart(cashier)}
                                                    </div>

                                                    <div className="text-sm text-dark text_caps-small">
                                                    {cashierDayEnd(cashier)}
                                                    </div>
                                                </span>
                                            </div>
                                            <Col className="col-auto">
                                                <div
                                                    className="icon icon-shape bg-teal text-white rounded-circle shadow">
                                                    <i className="fas fa-cash-register"/>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>
            }
        </div>
    );
};

export default DayOverview;